import { getLocalApi } from "./localApi";
import apiConfig from "app/api/apiConfig.json";
import { ApiErrors } from "./ApiErrors";
import { DivisionId } from "app/shared/division/getDivisionId";

export interface SaveAccountCategoryParams {
  id?: number;
  name: string;
  active: boolean;
  divisionId?: number;
}

export async function saveAccountCategory(
  category: SaveAccountCategoryParams
): Promise<{ ok: boolean; message: string; errors?: string[]; data?: any }> {
  const localApi = await getLocalApi();

  const payload = {
    id: category.id ?? 0,
    name: category.name,
    divisionId: category.divisionId ?? DivisionId(),
    active: !!category.active,
  };

  const method = "POST";
  const result = await localApi.call(
    (apiConfig as any).reference_data_account_category,
    method,
    JSON.stringify(payload)
  );

  if (!result) {
    return {
      ok: false,
      message: "No response from API",
      data: null,
    };
    }

  const raw = await result.text();
  let data: any = null;
  try {
    data = raw ? JSON.parse(raw) : null;
  } catch {
  }

  const errors = ApiErrors.extractAllErrors(data, result, "Failed to save account category");
  const message = result.ok
    ? (data?.message || "Saved")
    : ApiErrors.formatErrors(errors);

  return {
    ok: result.ok,
    message,
    errors: result.ok ? undefined : errors,
    data,
  };
}